import { render, staticRenderFns } from "./StudentCard.vue?vue&type=template&id=55743310&scoped=true"
import script from "./StudentCard.vue?vue&type=script&lang=js"
export * from "./StudentCard.vue?vue&type=script&lang=js"
import style0 from "./StudentCard.vue?vue&type=style&index=0&id=55743310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55743310",
  null
  
)

export default component.exports